import { Component, Input, OnInit } from '@angular/core';
import { Payline, PaylineType, PayTypes } from '../../../../models/payroll';

@Component({
  selector: 'lib-payline-detail-totals',
  templateUrl: './payline-detail-totals.component.html',
  styleUrls: ['./payline-detail-totals.component.scss'],
  standalone: false
})
export class PaylineDetailTotalsComponent implements OnInit {
  @Input() public payline: Payline;
  @Input() public payrollType: PayTypes;
  @Input() showHoldPaymentColumn: boolean = false;
  public hideDeposits: boolean;

  // expose paylineType enum for references in template
  public readonly paylineType: typeof PaylineType = PaylineType;

  constructor() {}

  ngOnInit() {
    this.hideDeposits =
      this.payline?.DirectDeposits?.length == 0 ||
      [PaylineType.Manual, PaylineType.Void, PaylineType.NoCheck].includes(
        this.payline?.PaylineType
      ) ||
      this.payrollType == PayTypes.Manual ||
      this.payrollType == PayTypes.Adjustment;
  }
}
